import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { getPendingInviteCode } from '../lib/inviteCode';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await authAPI.exchangeSession(sessionId);
        login(res.data.user, res.data.player, res.data.has_ladder_access, res.data.profile_completed);
        window.history.replaceState(null, '', window.location.pathname);
        const pendingCode = getPendingInviteCode();
        // Pending invite code in hand always wins — even for approved users.
        if (pendingCode) {
          navigate(`/onboard?code=${pendingCode}`, { replace: true });
          return;
        }
        if (!res.data.profile_completed) {
          navigate('/complete-profile', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        const detail = err.response?.data?.detail || 'Login failed';
        navigate('/login', { replace: true, state: { error: detail } });
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fbfaf8]">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#015e3f] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#6a766e] font-sans">Signing you in...</p>
      </div>
    </div>
  );
}
